// extracted by mini-css-extract-plugin
export default {"navContent":"MobileNav_navContent__edLdi","nav":"MobileNav_nav__zONtr","navSection":"MobileNav_navSection__6GdHk"};